/* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

/* AUTH */
export const ADD_SCHOOL = "ADD_SCHOOL";
export const ADD_SCHOOL_SUCCESS = "ADD_SCHOOL_SUCCESS";
export const ADD_SCHOOL_ERROR = "ADD_SCHOOL_ERROR";
/* SCHOOL */
export const GET_PROGRAMS = "GET_PROGRAMS";
export const GET_PROGRAMS_SUCCESS = "GET_PROGRAMS_SUCCESS";
export const GET_PROGRAMS_ERROR = "GET_PROGRAMS_ERROR";

export const GET_FIELD_OF_STUDY = "GET_FIELD_OF_STUDY";
export const GET_FIELD_OF_STUDY_SUCCESS = "GET_FIELD_OF_STUDY_SUCCESS";
export const GET_FIELD_OF_STUDY_ERROR = "GET_FIELD_OF_STUDY_ERROR";

export const GET_CURRENCY = "GET_CURRENCY";
export const GET_CURRENCY_SUCCESS = "GET_CURRENCY_SUCCESS";
export const GET_CURRENCY_ERROR = "GET_CURRENCY_ERROR";

export const GET_QUALIFICATION = "GET_QUALIFICATION";
export const GET_QUALIFICATION_SUCCESS = "GET_QUALIFICATION_SUCCESS";
export const GET_QUALIFICATION_ERROR = "GET_QUALIFICATION_ERROR";

export const GET_STUDY_LEVEL = "GET_STUDY_LEVEL";
export const GET_STUDY_LEVEL_SUCCESS = "GET_STUDY_LEVEL_SUCCESS";
export const GET_STUDY_LEVEL_ERROR = "GET_STUDY_LEVEL_ERROR";

export const GET_SCHOOL_FOS = "GET_SCHOOL_FOS";
export const GET_SCHOOL_FOS_SUCCESS = "GET_SCHOOL_FOS_SUCCESS";
export const GET_SCHOOL_FOS_ERROR = "GET_SCHOOL_FOS_ERROR";

export const ADD_SCHOOL_PROGRAM = "ADD_SCHOOL_PROGRAM";
export const ADD_SCHOOL_PROGRAM_SUCCESS = "ADD_SCHOOL_PROGRAM_SUCCESS";
export const ADD_SCHOOL_PROGRAM_ERROR = "ADD_SCHOOL_PROGRAM_ERROR";

export const DELETE_SCHOOL_PROGRAM = "DELETE_SCHOOL_PROGRAM";
export const DELETE_SCHOOL_PROGRAM_SUCCESS = "DELETE_SCHOOL_PROGRAM_SUCCESS";
export const DELETE_SCHOOL_PROGRAM_ERROR = "DELETE_SCHOOL_PROGRAM_ERROR";

export const ADD_SCHOOL_FOS = "ADD_SCHOOL_FOS";
export const ADD_SCHOOL_FOS_SUCCESS = "ADD_SCHOOL_FOS_SUCCESS";
export const ADD_SCHOOL_FOS_ERROR = "ADD_SCHOOL_FOS_ERROR";

export const DELETE_SCHOOL_FOS = "DELETE_SCHOOL_FOS";
export const DELETE_SCHOOL_FOS_SUCCESS = "DELETE_SCHOOL_FOS_SUCCESS";
export const DELETE_SCHOOL_FOS_ERROR = "DELETE_SCHOOL_FOS_ERROR";

export * from "./schools/actions";
